import styled, { css } from "styled-components";
import { unitCalc } from "calcite-react/utils/helpers";

import CalciteButton from "calcite-react/Button";

const StyledButton = styled(CalciteButton)`
  ${props =>
    props.gapRight &&
    css`
      margin-right: ${props => unitCalc(props.theme.baseline, 2, "/")};
    `};
`;

export { StyledButton };
